import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import WbmImage from '../../../../Shared/components/wbmImage';
import ChatScript from '../../../../ContactChat/src/app/components/chatScript';

import ConfigPropMapService from '../../../../Shared/services/configPropMapService';
import NavTokenMapService from '../../../../Shared/services/navTokenMapService';

import ConfigPropId from '../../../../Shared/constants/configPropId';
import NavigationTokens from '../../../../Shared/constants/navigationTokens';
import csrContactTypeEnum from '../../../../YourDedicatedTeams/src/app/consts/CSRContactTypeEnum';

class SecondRow extends React.PureComponent {
    retrieveBaseNavLink(navTokenName) {
        return NavTokenMapService.getNavToken(navTokenName).url;
    }

    getContactUrl(contactType, showGenericCsr) {
        return this.retrieveBaseNavLink(NavigationTokens.CustomerService) + (showGenericCsr ? "" : `?cntp=${contactType}`);
    }

    getChat() {
        let isChatEnabled = ConfigPropMapService.getConfigPropbyId(ConfigPropId.EnableCafeXWebChat).value;
        let webChatId = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ContactUsEmbeddedWebChatId).value;

        return (
            isChatEnabled && this.props.chatScript != null && <React.Fragment>
                <ChatScript
                    script={this.props.chatScript}
                    embeddedWebChatId={webChatId}
                    className="grid-link"
                />
                    <div className="icon-divider" />
            </React.Fragment>);
    }
  
    getDefaultRepImage(contactType) {
        switch (contactType)
        {
            case csrContactTypeEnum.SalesRep:
                return ConfigPropMapService.getConfigPropbyId(ConfigPropId.DefaultSalesRepImage).value;
            default:
                return ConfigPropMapService.getConfigPropbyId(ConfigPropId.DefaultCustomerServiceRepImage).value;
        }
    }

    getGenericRepView(contactType) {
        let isGeneric = contactType === "PrimaryCSR" && this.props.customerServiceInfo.contacts.length === 0;

        let genericCSR = {
            name: ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServiceRepTitle).value,
            email: ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServiceEmail).value,
            imageURL: ConfigPropMapService.getConfigPropbyId(ConfigPropId.DefaultCustomerServiceRepImage).value,
            phone: ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServicePhoneNumberSmall).value
        };

        let baseRepInfo = isGeneric ? genericCSR : _.findWhere(this.props.customerServiceInfo.contacts, { contactType: contactType });

        return baseRepInfo &&
            <React.Fragment>
                <div className="grid-link rep">
                    <div className="icon-image">
                        <WbmImage
                            className="icon-image"
                            src={baseRepInfo.imageURL}
                            altText={baseRepInfo.name ? baseRepInfo.name : baseRepInfo.title}
                            defaultImageUrl={this.getDefaultRepImage(csrContactTypeEnum[contactType])}
                        />
                    </div>
                    <div className="icon-text">
                    <span><b>{baseRepInfo.name ? baseRepInfo.name : baseRepInfo.title}</b></span> <br />
                    {baseRepInfo.name && baseRepInfo.title ? <span>{baseRepInfo.title}<br /></span> : null}
                        <span>{baseRepInfo.email}</span> <br />
                        <span >{baseRepInfo.phone}</span> <br />

                        {baseRepInfo.email ?
                            <div className='rep-contact-button'>
                            <a href={this.getContactUrl(csrContactTypeEnum[contactType], isGeneric)} className='yellow-button-square medium rep-contact-link'> Contact </a>
                            </div> : null}
                    </div>
                </div>
                <div className="icon-divider" />
            </React.Fragment>;
    }

    getPhoneInfo() {
        let customerServicePhoneNum = ConfigPropMapService.getConfigPropbyId(ConfigPropId.CustomerServicePhoneNumber).value;
        let imageLink = "ClientApps/Assets/Images/ContactUs/contactus-CSPhone.png?v=1";

        return customerServicePhoneNum &&
            <React.Fragment>
                <div className="grid-link">
                    <div className="icon-image">
                    <img
                        className="icon-image"
                        src={imageLink}
                        alt="CSR Phone Icon"
                        width="160px"
                        height="160px"
                    />
                    </div>
                    <div className="icon-text wbmblue">
                        <b>{customerServicePhoneNum}</b>
                    </div>
                </div>
                <div className="icon-divider" />
            </React.Fragment>;
    }

    render() {
        return (
            <React.Fragment>
                {this.getChat()}
                {this.getGenericRepView("SalesRep")}
                {this.getGenericRepView("PrimaryCSR")}
                {this.getPhoneInfo()}
            </React.Fragment>);
    }
}
function mapStateToProps(state) {
    return {
        chatScript: state.chatScript,
        customerServiceInfo: state.customerServiceInfo
    };
}
export default connect(mapStateToProps)(SecondRow);
